import * as React from 'react';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

const iconWrapperVariants = cva('relative inline-flex items-center justify-center shrink-0 rounded-sm border-0 leading-none [&_svg]:relative [&_svg]:min-w-4 transition align-middle', {
  variants: {
    size: {
      default: 'size-8 p-1.5',
      xs: 'size-4 p-1',
      sm: 'size-6 p-1',
      md: 'size-10 p-2',
      lg: 'size-12 p-2.5'
    },
    color: {
      primary: 'bg-primary-lightest text-primary',
      secondary: 'bg-secondary-lightest text-secondary'
    }
  },
  defaultVariants: {
    size: 'default',
    color: 'primary'
  }
});

const IconWrapper = React.forwardRef(({ className, size, color, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-icon-wrapper', iconWrapperVariants({ size, color, className }))}
    {...props}
  />
));
IconWrapper.displayName = 'IconWrapper';

export { IconWrapper };
